import { gql } from '@apollo/client';

import { VIDEO_FRAGMENT } from './fragments';

// Mutation to send a magic link
export const SEND_MAGIC_LINK = gql`
  mutation SendMagicLink($email: String!) {
    sendMagicLink(email: $email) {
      id
    }
  }
`;

// Query to validate JWT token
export const JWT_AUTH = gql`
  mutation JwtAuth($jwt: String!) {
    jwtAuth(jwt: $jwt) {
      id
      email
      jwt
      role
    }
  }
`;

// Query to get user data
export const GET_USER = gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      id
      email
      videos {
        ...VideoFragment
      }
      jwt
      role
    }
  }

  ${VIDEO_FRAGMENT}
`;

export const GET_USERS = gql`
  query GetUsers {
    users {
      id
      email
      role
      insta_login_link
      total_videos
      first_video_created_at
      last_video_created_at
      videos_count_by_website_source
      created_at
    }
  }
`;

// Query to get available avatars
export const GET_AVATARS = gql`
  query GetAvatars {
    avatars {
      id
      name
      description
      preview_video_url
      preview_image_url
      default_heygen_voice_id
      default_voice {
        id
      }
    }
  }
`;

export const GET_VIDEOS = gql`
  query GetVideos {
    videos {
      ...VideoFragment
    }
  }

  ${VIDEO_FRAGMENT}
`;

// Mutation to create draft video
export const CREATE_DRAFT_VIDEO = gql`
  mutation CreateVideoDraft($script: String!, $image_urls: [String!], $heygen_template_id: String, $avatar_id: ID!, $voice_id: ID, $scraped_website_url: String!, $scraped_data: JSON!, $scrape_result_id: ID) {
    createVideoDraft(script: $script, image_urls: $image_urls, heygen_template_id: $heygen_template_id, avatar_id: $avatar_id, voice_id: $voice_id, scraped_website_url: $scraped_website_url, scraped_data: $scraped_data, scrape_result_id: $scrape_result_id) {
      id
    }
  }
`;

// Mutation to edit a video
export const EDIT_VIDEO = gql`
  mutation EditVideo($video_id: ID!, $script: String!, $image_urls: [String!]!) {
    editVideo(video_id: $video_id, script: $script, image_urls: $image_urls) {
      id
    }
  }
`;

// Mutation to create Stripe checkout session
export const CREATE_STRIPE_SESSION = gql`
  mutation CreateStripeCheckoutSession($video_id: ID!) {
    createStripeCheckoutSession(video_id: $video_id) {
      checkout_session_url
      checkout_session
    }
  }
`;

// Mutation to process Stripe checkout
export const PROCESS_STRIPE_CHECKOUT = gql`
  mutation ProcessStripeCheckout($checkout_session_id: String!) {
    processStripeCheckout(checkout_session_id: $checkout_session_id) {
      redirect_url
    }
  }
`;

// Mutation to create scraping job
export const CREATE_SCRAPING_JOB = gql`
  mutation CreateScrapingJob($scraped_website_url: String!) {
    triggerScrapeWebsiteDataJob(websiteUrl: $scraped_website_url) {
      extractionJobId
    }
  }
`;

export const GET_SCRAPING_JOB_DATA = gql`
  mutation GetScrapingJobData($jobId: String!) {
    retrieveScrapeWebsiteDataJobResults(extraction_job_id: $jobId){
      success
      extraction_job_status
      image_urls
      script
      errors
      extraction_job_id
      scraped_info
      debug_info
    }
  }
`;

// Admin dashboard overview data
export const GET_ADMIN_DASHBOARD_DATA = gql`
  query GetAdminDashboardData($start_date: Int!, $end_date: Int!) {
    usage_stats(start_date: $start_date, end_date: $end_date){
      id
      date_range
      paid_users_count
      video_count
      new_users_count
      avg_videos_per_user
      videos_count_by_website_source_graph_data
      videos_created_by_day_graph_data
    }
  }
`;

// Mutation to mark video as downloaded
export const MARK_VIDEO_AS_DOWNLOADED = gql`
  mutation MarkVideoAsDownloaded($video_id: ID!) {
    markVideoAsDownloaded(video_id: $video_id) {
      id
      downloaded
    }
  }
`;
